// extracted by mini-css-extract-plugin
export default {"page":"HY-z","cartModal":"IY-z","checkout":"JY-z","placeholder":"KY-z","account":"LY-z"};